export default {
  namespaced: true,
  state: {
    cacheFlags: {
      customers: {
        invoices: true,
        quotations: true,
        costs: true,
        recurrent: true,
        trips: true,
        hours: true
      }
    }
  },
  getters: {
    isCacheEnabled: (state) => (section, type) => {
      return !!(state.cacheFlags[section] && state.cacheFlags[section][type])
    }
  },
  mutations: {
    SET_CACHE_FLAG (state, { section, type, flag }) {
      if (!state.cacheFlags[section]) {
        state.cacheFlags[section] = {}
      }
      state.cacheFlags[section][type] = flag
    }
  },
  actions: {
    enableCache ({ commit }, { section, type }) {
      commit('SET_CACHE_FLAG', { section, type, flag: true })
    },
    disableCache ({ commit }, { section, type }) {
      commit('SET_CACHE_FLAG', { section, type, flag: false })
    }
  }
}
